import type { Transaction } from '@shared/transactions-types';
import { TransactionType } from '@shared/transactions-types';
import { getFeatureConfig } from '@luna/feature-config';

import { isType } from '../../predicates/isType';

export const getPartnerName = (transaction: Transaction): string | null => {
    const { addAllTypes } = getFeatureConfig(({ transactions }) => transactions.writtenItems);
    const { partnerName, bookingTypeTranslation, saving } = transaction;

    if (!addAllTypes) {
        return partnerName;
    }

    if (isType(TransactionType.BANK_FEE)(transaction) && bookingTypeTranslation) {
        return bookingTypeTranslation;
    }

    if (isType(TransactionType.SECURITIES)(transaction) && saving?.membershipFund) {
        return `${bookingTypeTranslation} ${saving?.membershipFund}`;
    }

    return partnerName;
};
